import { Country } from '@core/modules/countries/models';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LOGIN } from '@core/constants/RoutingsPath';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '@core/modules/authentication/services/auth.service';
import { Observable, catchError, of, tap } from 'rxjs';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RegisterComponent implements OnInit {
  loginPath = `/${LOGIN}`;

  verifyingEmail = {
    isShown: false,
    email: ''
  };

  register$: Observable<any> = of();

  redirectUrl?: string;

  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.redirectUrl = params.url;
    });
  }

  onSubmit(formValues: any) {
    const { email, countryId, password, promotions } = formValues;
    this.register$ = this.authService
      .register({ email, countryId, password, promotions, redirectUrl: this.redirectUrl })
      .pipe(
        tap(() => {
          this.verifyingEmail = {
            isShown: true,
            email
          };
        }),
        catchError((error) => {
          console.error('Error register : ', error);

          return of('error');
        })
      );
  }
}
